import { render, staticRenderFns } from "./TeamSodEodReview.vue?vue&type=template&id=ab63876a&scoped=true"
import script from "./TeamSodEodReview.vue?vue&type=script&lang=js"
export * from "./TeamSodEodReview.vue?vue&type=script&lang=js"
import style0 from "./TeamSodEodReview.vue?vue&type=style&index=0&id=ab63876a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab63876a",
  null
  
)

export default component.exports